// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutSplitButton_container__uYOw3","button":"CheckoutSplitButton_button__2HtGX","disabled":"CheckoutSplitButton_disabled__1jSdQ"};